import type { DroneServiceType } from '../../services/droneServiceService';

type LayerToggleStyles = {
  section: string;
  emptyIconWrap: string;
  sectionIcon: string;
  heading: string;
  muted: string;
  primaryBtn: string;
};

/** Compact in-panel CTA (same pattern as Drone → sample data service block). Opens {@link DroneServiceRequestModal} via parent. */
export function FieldServiceRequestCta({
  iconClass,
  title,
  description,
  buttons,
  onRequest,
  lt,
  embedded,
}: {
  iconClass: string;
  title: string;
  description: string;
  buttons: { label: string; serviceType: DroneServiceType }[];
  onRequest: (type: DroneServiceType) => void;
  lt: LayerToggleStyles;
  embedded?: boolean;
}) {
  return (
    <div className={`mt-3 sm:mt-4 p-3 sm:p-4 ${lt.section}`}>
      <div className="flex items-start space-x-2 sm:space-x-3">
        <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg sm:h-10 sm:w-10 ${lt.emptyIconWrap}`}>
          <i className={`${iconClass} ${lt.sectionIcon} text-lg sm:text-xl`} aria-hidden />
        </div>
        <div className="min-w-0 flex-1">
          <h4 className={`mb-1 text-xs font-semibold sm:mb-1.5 sm:text-sm ${lt.heading}`}>{title}</h4>
          <p className={`mb-2 text-sm sm:mb-3 ${lt.muted}`}>{description}</p>
          <div className="space-y-1.5 sm:space-y-2">
            {buttons.map((btn) => (
              <button
                key={btn.serviceType}
                type="button"
                onClick={() => onRequest(btn.serviceType)}
                className={`drone-service-cta-btn flex w-full items-center justify-center space-x-1.5 rounded-md border-0 px-3 py-1.5 text-sm font-medium text-white transition-all duration-200 sm:space-x-2 sm:px-4 sm:py-2 ${lt.primaryBtn} ${
                  embedded ? 'shadow-md hover:shadow-lg' : 'shadow-sm hover:shadow-md'
                }`}
              >
                <i className="ri-customer-service-2-line text-white" aria-hidden />
                <span className="text-white">{btn.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
